import {ApiService,DataService,UserService} from '@/service'
import { Category, WinForm} from "@digital-supply-chain/module";
import {Message,MessageBox} from "element-ui";

let powerAllow: any = {};

export class AuthorityServer {

  /**
   * 更新授权数据
   * @param categoryId  授权数据类型， 目录，数据
   * @param datas    授权的数据【】
   * @param power    授权数据的 权限参数{download,edit,view,del}
   */
  static powerBatchSave(datas: Array<any>, power: any = null) {
    let entity = datas.map((item: any) => {
      return {
        "CategoryID": item.CategoryID,
        "DataID": item.DataID,
        "Powers": [
          {
            "BeCompID": item.BeCompID,
            "BeOrgID": item.BeOrgID,
            "BeUserID": item.BeUserID,
            "ExpiryDate": item.ExpiryDate,
            "Power": power
          }
        ]
      }
    });
    return DataService.post(`${ApiService.JrzzApi}/power/batchsave`, entity);
  }


  /**
   * 更新授权数据
   * @param categoryId  授权数据类型， 目录，数据
   * @param dataId    授权数据的id
   * @param datas    授权的数据【】
   * @param power    授权数据的 权限参数{download,edit,view,del}
   */
  static powerUpdata(categoryId: number, dataId: any, datas: Array<any>, power: any = null) {
    let entity = datas.map((item: any) => {
      return {
        "CategoryID": categoryId,
        "DataID": dataId,
        "Powers": [
          {
            "BeCompID": item.BeCompID,
            "BeOrgID": item.BeOrgID,
            "BeUserID": item.BeUserID,
            "ExpiryDate": item.ExpiryDate,
            "Power": power
          }
        ]
      }
    });
    return DataService.post(`${ApiService.JrzzApi}/power/batchsave`, entity);
  }


  /**
   * 检查是否有权限
   *@param categoryId  授权数据类型， 目录，数据
   * @param dataId    授权数据的id
   * @param keys    检查的权限key add  view
   */
  static async powerAllow(categoryId: number, dataId: number, keys: Array<any>, ownerId?: number) {
    if ((dataId > 0 && UserService.userID() == ownerId) || (dataId == 0 && !UserService.isComp())) {
      const Obj: any = {};
      keys.forEach(key => Obj[key] = true);
      return Obj;
    }
    const PowerAllowObj = keys.map(key => {
      return {
        "Key": key,
        "DefaultValue": key === "download" && categoryId == Category.Document
      }
    });
    return powerAllow[`${categoryId}_${dataId}`] = powerAllow[`${categoryId}_${dataId}`] || await DataService.post(`${ApiService.JrzzApi}/power/${categoryId}/allow?dataId=${dataId}`, PowerAllowObj);
  }

  /**
   * 检查是否有权限
   * @param params  [{"CategoryID": 0,"DataID": 0,"Key": "string","DefaultValue": true}]
   */

  static powerBatchAllow(params: Array<{ CategoryID: number, DataID: number, Key: string, DefaultValue?: boolean }>, userId: number = 0) {
    params.forEach(item => {
      item.DefaultValue = item.CategoryID === Category.Document && item.Key == "download"
    })
    let url = `${ApiService.JrzzApi}/power/batchallow`;
    if (userId) {
      url += `?userId=${userId}`;
    }
    return DataService.post(url, params);
  }

  /**
   * 获取授权人员
   * @param categoryId  授权类目Id
   * @param dataId  数据id
   * @param key  授权项
   * @param value  类型
   */

  static getAuthUsers(categoryId: number, dataId: number, key: string, value: number = 1) {
    return DataService.get(`${ApiService.JrzzApi}/power/${categoryId}/authusers`, {dataId, key, value});
  }

  /**
   * 批量取消授权
   * @param params { CategoryID, DataID, DataCompID, DataUserID }
   */
  static batchCancelPower(params: Array<{ CategoryID: number, DataID: number, DataCompID: number, DataUserID: number }>) {
    return DataService.post(`${ApiService.JrzzApi}/power/cancel`, params);
  }

  static async cancelPowers(args: Array<any>, emitKey: string) {
    let res = await MessageBox.confirm('确定取消授权么？', '提示', {type: 'warning'});
    if (!res) return;
    let params: Array<any> = [];
    args.forEach(item => {
      if (item.ShareArea) {
        const {CategoryID, ID, CreateComp, OwnerComp, Owner, CreateUser} = item;
        const DataCompID = CreateComp || OwnerComp;
        const DataUserID = Owner || CreateUser;
        params.push({CategoryID, DataID: ID, DataCompID, DataUserID})
      }
    })
    AuthorityServer.batchCancelPower(params).then(() => {
      Message.success("取消授权成功！");
      WinForm.md.$emit(emitKey, {Datas: params, authedLen: 0})
    });
  }


  static vipGrant(tip: string = '授权功能，仅对会员用户生效，请开通后重试！') {
    // if (!UserService.isSVip()) {
    //   MessageBox.alert(tip, '',
    //       {confirmButtonText: '开通会员', type: "warning"}).then(res => {
    //     if (!res) return;
    //     OpenService.openBuyVip();
    //   });
    //   return false;
    // }
    return true;
  }
}